var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6142 0.682126L21.3159 9.0211C21.4552 9.33493 21.6772 9.6061 21.9587 9.80629C22.2402 10.0065 22.571 10.1284 22.9165 10.1592L31.9343 10.9578C32.9546 11.1045 33.3616 12.3404 32.6218 13.0521L25.8289 18.6883C25.2789 19.1447 25.0286 19.8618 25.1799 20.5544L27.1545 29.6838C27.3278 30.6861 26.2635 31.4521 25.3504 30.9768L17.4795 26.4243C17.1826 26.2522 16.8446 26.1615 16.5004 26.1615C16.1562 26.1615 15.8182 26.2522 15.5214 26.4243L7.65046 30.9741C6.74016 31.4467 5.67311 30.6834 5.84637 29.6811L7.82097 20.5517C7.96948 19.8591 7.72197 19.142 7.17194 18.6856L0.376326 13.0548C-0.360714 12.3458 0.0463082 11.1072 1.06386 10.9605L10.0816 10.1619C10.4271 10.1311 10.7579 10.0092 11.0394 9.80901C11.321 9.60882 11.5429 9.33765 11.6822 9.02382L15.3839 0.684842C15.8431 -0.227828 17.1577 -0.227827 17.6142 0.682126Z",
    fill: "#FDD835"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3447 9.52094L16.7176 3.37672C16.6929 3.03447 16.6214 2.44775 17.1769 2.44775C17.6169 2.44775 17.8562 3.35227 17.8562 3.35227L19.7373 8.28504C20.4468 10.162 20.1553 10.8057 19.4705 11.186C18.684 11.6206 17.5234 11.2811 17.3447 9.52094Z",
    fill: "#FFFF8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1025 18.1423L30.4983 13.9837C30.7651 13.7636 31.2464 13.4132 30.8613 13.014C30.5561 12.6989 29.731 13.1525 29.731 13.1525L25.009 14.9751C23.601 15.4559 22.6659 16.1676 22.5834 17.0639C22.4762 18.2591 23.5625 19.1799 25.1025 18.1423Z",
    fill: "#F4B400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarGold);
export default __webpack_public_path__ + "static/media/star-gold.1d3fa7a6ba7089e6e546fa3537b96cd8.svg";
export { ForwardRef as ReactComponent };